var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button",
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  {
    id: "seq_id",
    label: "Unique Key",
    type: types.INPUT,
  },
  {
    // This field should be used as a reference to the certificate table.
    id: "certificate_seq_id",
    label: "証書管理番号(ref)",
    type: types.INPUT,
    import: {
      enabled: true,
    },
  },
  {
    // 1
    id: "certificate_software_number", // Renamed from  "ref_id",
    label: "証書管理番号",
    type: types.INPUT,
    import: {
      enabled: true,
      alias: ["証書管理番号\r\n(必須)"],
    },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software_deposit:"F",
      certificate_software:"D",
      surplus_license: "C"
    },
  },
  {
    // 2
    id: "maker",
    label: "メーカ",
    // force_select_first_option:true,
    type: types.SELECT_BOX4,
    error_if_blank: true,
    api_uniq_grouping:true,
    api: "/master_maker/list_maker_name",
    // It emit a event to be received by BOX4 and execute a filter.
    event_emit_bus_key: "certificate_software_manufacture_name_software_name",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_information: "I",
      certificate_software:"J",
      certificate_software_deposit:"B",
      surplus_license: "B"
    },
  },
  {
    // 3
    id: "software_name",
    label: "ソフトウェア名",
    type: types.SELECT_BOX4,
    error_if_blank:true,
    api_uniq_grouping:true,
    api: "/master_software/list_software_name_maker_name",
    error_if_blank: true,
    import: { enabled: true },
    api_field_name:"software_name",
    api_filter_to_other_field:{
      by_field:"maker",
      compare_api_key:"maker_name",
      filter_data_on_event:"certificate_software_manufacture_name_software_name",
    },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "K",
      surplus_license: "D"
    },
  },

  {
    //4
    id: "license_name",
    label: "ライセンス名",
    type: types.INPUT,
    error_if_blank: true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software_deposit:"C",
      certificate_software:"L"
    },
  },
  {
    //5
    id: "jurisdiction_classification",
    label: "所管区分",
    type: types.SELECT_BOX,
    error_if_blank: true,
    options: ["EUC・その他", "IT所管システム"],
    import: { enabled: true },
    api_uniq_grouping:true,
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "F",
    },
  },
  {
    //6
    id: "company",
    label: "ライセンス所管会社",
    type: types.SELECT_BOX4,
    error_if_blank: true,
    page_controller: true,
    api_uniq_grouping:true,
    default_from_local_storage: "userCompany",
    // api: "/master_company/list_company_name",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"company",
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "E",
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"licensed_department",api:"department"},
        team:{field:"license_jurisdiction_team",api:"team"}
      },
      clear_on_reset:["licensed_department","license_jurisdiction_team"]
    }
  },

  {
    // 7
    id: "licensed_department",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank: true,
    // api: "/master_belongs/list_department",
    default_from_local_storage: "userDepartment",
    limit_department_on_search: true,
    // global_emit:"licensed_department_selected",
    api: "/master_belongs/list_team_and_department",
    api_field_name:"department",
    page_controller: true,
    api_uniq_grouping:true,
    search_option: {
      define_department_limit_to_key: "license_jurisdiction_team",
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "G",
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"licensed_department",api:"department"},
        team:{field:"license_jurisdiction_team",api:"team"}
      },
      clear_on_reset:["license_jurisdiction_team"]
    }
  },
  {
    // 8
    id: "license_jurisdiction_team",
    label: "ライセンス所管チーム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank: true,
    default_from_local_storage: "userTeam",
    api: "/master_belongs/list_team_and_department",
    api_field_name: "team",
    api_uniq_grouping:true,
    // sort_result:true,
    limit_department_on_search: true,
    // api_filter_to_other_field:{
    //   by_field:"licensed_department",
    //   compare_api_key:"department",
    //   filter_data_on_event:"licensed_department_selected",
    // },
    page_controller: true,
    search_option: {
      define_department_limit_by_key: "licensed_department",
      api_field_name: "department",
    },
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "H",
    },
    search_dependency:{
      algorithm:"company",
      fields:{
        company: {field:"company",api:"company"},
        department:{field:"licensed_department",api:"department"},
        team:{field:"license_jurisdiction_team",api:"team"}
      },
      clear_on_reset:[]
    }
  },
  {
    // 9
    id: "license_jurisdiction_system",
    label: "ライセンス所管システム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    error_if_blank: true,
    api_uniq_grouping:true,
    api: "/master_system/list_system_name",
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "I",
    },
  },
  {
    //10
    id: "equipment_in_charge_system",
    label: "所管システム/用途",
    type: types.INPUT,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //11
    id: "product_key",
    label: "プロダクトキー",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    //12
    id: "upgrade",
    label: "アップグレード",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    default_value: "無",
    import: {
      enabled: true,
      alias: ["アップグレード\r\n(有/無)"],
    },
  },
  {
    id: "upgrade_source",
    label: "アップグレード元",
    type: types.INPUT,
    error_if_blank: true,
    min_value: "0",
    import: { enabled: true },
  },
  {
    id: "upgrade_destination",
    label: "アップグレード先",
    type: types.INPUT,
    read_only: true,
    disabled:true,
    min_value: "0",
    import: { enabled: true },
  },
  {
    //14
    id: "deadline_alert",
    label: "有効期限　有無",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
    },
  },
  {
    //15
    id: "expiration_date",
    label: "有効期限",
    type: types.DATE_PICKER,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software:"Q",
      surplus_license: "F"
    },
  },
  {
    //16
    id: "maintenance_deadline",
    label: "保守期限",
    type: types.DATE_PICKER,
    import: { enabled: true, date_format: "YYYY-MM-DD" },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software:"R",
      surplus_license: "G"
    },
  },
  {
    //17
    id: "second_number",
    label: "セカンド数",
    type: types.INPUT,
    field_type: "number",
    min_value: "0",
    import: { enabled: true },
  },
  {
    //18
    id: "unlimited",
    label: "無制限",
    type: types.SELECT_BOX,
    no_blank: true,
    default_value: "ー",
    options: ["無制限", "ー"],
    import: {
      enabled: true,
      alias: ["無制限\r\n(無制限/-)"],
      sequence: 1000,
      certificate_software: "M",
    },
    export: { 
      enabled: true,
      sequence: 1000,
      certificate_software: "M",
    },
  },
  {
    //19
    id: "license",
    label: "ライセンス数",
    type: types.INPUT,
    error_if_blank: true,
    field_type: "number",
    min_value: "1",
    import: { enabled: true },
    export: { 
      enabled: true, sequence: 1000 ,
      certificate_software_deposit:"E",
      surplus_license: "E",
      certificate_software: "N",
    },
    
  },
  {
    //20
    id: "applicant_name",
    label: "申請者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    error_if_blank: true,
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    //21
    id: "management_person_name",
    label: "管理担当者名（ﾌﾙﾈｰﾑ）",
    type: types.INPUT,
    error_if_blank: true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //22
    id: "comprehensive_contract",
    label: "包括契約",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    //23
    id: "effective_number",
    label: "使用数",
    type: types.INPUT,
    exact_value:true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "O",
    },
  },
  {
    //24
    id: "remaining_number",
    label: "残数",
    exact_value:true,
    type: types.INPUT,
    tab_size: 20,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "P",
    },
  },
  {
    //5
    id: "remark",
    label: "備考",
    type: types.TEXT_AREA,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "retraction_reason",
    label: "差戻通知",
    type: types.TEXT_AREA,
    field_message:"※[差戻通知]は承認完了後削除されます。",
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },
  {
    id: "approval_status",
    label: "承認状態",
    type: types.SELECT_BOX,
    options: [
      "承認済", // Approved
      "申請中", // Applying
      "下書中", // In draft
      "差戻",
    ],
    table_field_style:{
      "承認済":"color:;",
      "申請中":"color:blue;",
      "下書中":"color:#a0283a",
      "差戻":"color:red;"
    },
    import: { enabled: false },
    export: { 
      enabled: true,
      sequence: 1000,
      certificate_software: "B",
      surplus_license: "A"
    },
  },
  {
    id: "status",
    label: "状態",
    type: types.SELECT_BOX,
    options: ["使用中", "廃棄"],
    import: { enabled: false },
    export: { 
      enabled: true, 
      sequence: 1000,
      certificate_software: "C"
    },
  },
  {
    id: "registration_date",
    label: "登録日",
    type: types.DATE_PICKER,
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software: "A"
    },
  },
  {
    id: "last_update_date",
    label: "最終更新日",
    type: types.DATE_PICKER,
  },
  {
    id: "second",
    label: "セカンド",
    tab_size:10,
    type: types.SELECT_BOX,
    default_value:"無",
    options: [
      "有", 
      "無", 
    ],
    import: { enabled: true },
  },
  {
    id: "downgrade",
    label: "アップ・ダウングレード",
    type: types.SELECT_BOX,
    options: ["有", "無"],
    import: { enabled: true },
    export: { enabled: true, sequence: 1000 },
  },

  { // Copy from certificate fields to be used at 預り証出力.
    //2
    id: "license_certificate_type",
    label: "ライセンス証書種類",
    type: types.INPUT,
    error_if_blank: true,
    import: { enabled: true },
    export: {
      enabled: true,
      sequence: 1000,
      certificate_software_deposit:"D"
    },
  },
  {
    //19
    id: "deadline_check",
    label: "期限チェック",
    tab_size:25,
    type: types.INPUT,
    error_if_blank: true,
    field_type: "number",
    min_value: "0",
    import: { enabled: true },
    export: {
      enabled: true, 
      sequence: 1000,
      surplus_license: "H",
   },
  },
  {
    id: "disable_validation",
    label: "disable_validation",
    type: types.INPUT,
  },
  {
    id: "status_at_approve_request",
    label: "status_at_approve_request",
    type: types.INPUT,
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if (!RegExp("^[a-z][a-z0-9_]+$").test(e.id)) {
    alert("Invalid field " + e.id);
  }
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_certificate_software.js